<script setup>
import { isEmpty } from 'lodash'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { ELEMENT_PROGRESS_CHART_TYPE_IDS, TARGET_LINES_COLOR } from '@/utils/objective-chart'

import ObjectiveChartTableColorMark from '@/components/objectives/chart/ObjectiveChartTableColorMark'

defineOptions({
  name: 'ElementProgressChartLegend'
})

const props = defineProps({
  chartData: {
    type: Object,
    required: true
  },

  progressColor: {
    type: String,
    required: true
  }
})

const { t } = useI18n()

const PROGRESS_LEGEND_ITEM = {
  color: props.progressColor
}

const TARGET_LEGEND_ITEM = {
  label: t('create.keyResult.label.targetValue'),
  color: TARGET_LINES_COLOR
}

const items = computed(() => {
  const { chartTypeId, chartLines, targetLines } = props.chartData

  if (!chartTypeId || !Object.values(ELEMENT_PROGRESS_CHART_TYPE_IDS).includes(chartTypeId)) {
    return []
  }

  const result = []

  if (chartLines && !isEmpty(chartLines)) {
    const labelByChartTypeId = {
      [ELEMENT_PROGRESS_CHART_TYPE_IDS.VALUES]: t('common.value'),
      [ELEMENT_PROGRESS_CHART_TYPE_IDS.PROGRESS]: t('objective.chart.progress')
    }

    result.push({
      ...PROGRESS_LEGEND_ITEM,
      label: labelByChartTypeId[chartTypeId]
    })
  }

  if (targetLines && !isEmpty(targetLines)) {
    result.push(TARGET_LEGEND_ITEM)
  }

  return result
})
</script>

<template>
  <div v-if="!isEmpty(items)" class="epcl-Legend">
    <div v-for="item in items" :key="item.color" class="epcl-LegendItem">
      <ObjectiveChartTableColorMark :color="item.color" />
      <div class="epcl-LegendItem_Label">{{ item.label }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.epcl-Legend {
  display: flex;
  gap: 24px;
}

.epcl-LegendItem {
  --marker-size: 10px;
  display: flex;
  gap: 4px;
  align-items: center;
  color: $dark-1;
  font-size: $fs-12;
  line-height: 16px;
  font-weight: fw('semi-bold');
}
</style>
